import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getPickupRequest,getPickupRequestV2,getPickupRequestbyId, postPickupRequest,editPickupRequest,
  importPickupRequests,getPickupTemplate,exportPickupRequests,exportAllPickupRequests,failedPickupRequest,cancelPickupRequest,
  applyPickupRequest,applyBulkPickupRequest,getPackageTrackEvent,postPickupConsignment,deletePickupConsignment,
  getConsignments,getConsignmentsDestination,postConsignmentsV3,getPickupConsignments,getPackages,exportPackages,
  exportConsignments,exportConsignmentsbyPost,assignSupplierPickupRequest,assignStationPickupRequest,postConsignments,getConsignmentStatus,getPickuprequestStatus,printPickupRequests,postPickupScheduleDate,postDeliveryScheduleDate,importPickupRequestsProof,importConsignmentDeliveryProof,
  applyConsignments,revokeConsignmentDisposed,importConsignmentPickupProof,bulkapplyConsignments,bulkapplyInScanConsignments,receiveSupplierBulk,importConsignmentSignatureProof,postSingleSupplier,postBulkSupplier,applyOfdConsignment,applyDeliveryConsignment,applyDeliveryFailedConsignment,bulkapplyRtoConsignments,bulkOfdRtoConsignments,revokeConsignmentDamage,revokeConsignmentLost,revokePickupConsignment,revokeCancelConsignment,revokeDeliveryConsignment,revokeSettleConsignment,revokeHoldConsignment,importDdu,dduUpdateTemplate,postPickupReschedule,
  reassignPickupRequest,
  unassignPickupRequest,
  cancelPickupWaybills} from "../../services/PickupRequest/pickuprequest_services"
const initialValues = {
  isPickupRequest: false,
  consignmentStatus: [],
  pickupStatus: []
};
let pickupStore = (set) => ({
  ...initialValues,
    getPickupRequest: async (params) => {
        const response = await getPickupRequest(params);
        return response;
      },
         getPickupRequestV2: async (params) => {
        const response = await getPickupRequestV2(params);
        return response;
      },
      getPickupRequestbyId: async (params) => {
        const response = await getPickupRequestbyId(params);
        return response;
      },
      postPickupRequest: async (params) => {
        const response = await postPickupRequest(params);
        return response;
      },
      editPickupRequest: async (params,data) => {
        const response = await editPickupRequest(params,data);
        return response;
      },
      importPickupRequests: async (params) => {
        const response = await importPickupRequests(params);
        return response;
      },
      importPickupRequestsProof: async (params,data) => {
        const response = await importPickupRequestsProof(params,data);
        return response;
      },
      importConsignmentDeliveryProof: async (params,data) => {
        const response = await importConsignmentDeliveryProof(params,data);
        return response;
      },
        importConsignmentPickupProof: async (params,data) => {
        const response = await importConsignmentPickupProof(params,data);
        return response;
      },
      importConsignmentSignatureProof: async (params,data) => {
        const response = await importConsignmentSignatureProof(params,data);
        return response;
      },
      getPickupTemplate: async () => {
        const response = await getPickupTemplate();
        return response;
      },
      exportPickupRequests: async (params) => {
        const response = await exportPickupRequests(params);
        return response;
      },
       exportAllPickupRequests: async (params) => {
        const response = await exportAllPickupRequests(params);
        return response;
      },
      cancelPickupRequest: async (params,data) => {
        const response = await cancelPickupRequest(params,data);
        return response;
      },
         failedPickupRequest: async (data) => {
        const response = await failedPickupRequest(data);
        return response;
      },
      applyPickupRequest: async (params,data) => {
        const response = await applyPickupRequest(params,data);
        return response;
      },
      applyBulkPickupRequest: async (params) => {
        const response = await applyBulkPickupRequest(params);
        return response;
      },
      assignSupplierPickupRequest: async (data) => {
        const response = await assignSupplierPickupRequest(data);
        return response;
      },
        assignStationPickupRequest: async (data) => {
        const response = await assignStationPickupRequest(data);
        return response;
      },
      getPackageTrackEvent: async (params) => {
        const response = await getPackageTrackEvent(params);
        return response;
      },
      postPickupConsignment: async (params,data) => {
        const response = await postPickupConsignment(params,data);
        return response;
      },
      applyConsignments: async (data) =>{
        const response = await applyConsignments(data);
        return response;
      },
      bulkapplyConsignments: async (params,data) =>{
        const response = await bulkapplyConsignments(params,data);
        return response;
      },
       bulkapplyInScanConsignments: async (params,data) =>{
        const response = await bulkapplyInScanConsignments(params,data);
        return response;
      },
      bulkapplyRtoConsignments: async (data) =>{
        const response = await bulkapplyRtoConsignments(data);
        return response;
      },
      bulkOfdRtoConsignments: async (data) =>{
        const response = await bulkOfdRtoConsignments(data);
        return response;
      },
      receiveSupplierBulk: async (data) =>{
        const response = await receiveSupplierBulk(data);
        return response;
      },
      revokePickupConsignment: async (params) =>{
        const response = await revokePickupConsignment(params);
        return response;
      },
      revokeConsignmentLost: async (params) =>{
        const response = await revokeConsignmentLost(params);
        return response;
      },
      revokeConsignmentDisposed: async (params) =>{
        const response = await revokeConsignmentDisposed(params);
        return response;
      },
      revokeConsignmentDamage: async (params) =>{
        const response = await revokeConsignmentDamage(params);
        return response;
      },
      revokeCancelConsignment: async (params) =>{
        const response = await revokeCancelConsignment(params);
        return response;
      },
      revokeDeliveryConsignment: async (params) =>{
        const response = await revokeDeliveryConsignment(params);
        return response;
      },
      revokeHoldConsignment: async (params) =>{
        const response = await revokeHoldConsignment(params);
        return response;
      },
        revokeSettleConsignment: async (params) =>{
        const response = await revokeSettleConsignment(params);
        return response;
      },
      applyOfdConsignment: async (params) =>{
        const response = await applyOfdConsignment(params);
        return response;
      },
      applyDeliveryConsignment: async (params) =>{
        const response = await applyDeliveryConsignment(params);
        return response;
      },
      applyDeliveryFailedConsignment: async (params) =>{
        const response = await applyDeliveryFailedConsignment(params);
        return response;
      },
      importDdu: async (params) =>{
        const response = await importDdu(params);
        return response;
      },
      dduUpdateTemplate: async () =>{
        const response = await dduUpdateTemplate();
        return response;
      },
      deletePickupConsignment: async (params,params2) => {
        const response = await deletePickupConsignment(params,params2);
        return response;
      },
      getConsignments: async (params) => {
        const response = await getConsignments(params);
        return response;
      },
      getConsignmentsDestination: async (params) => {
        const response = await getConsignmentsDestination(params);
        return response;
      },
      getPickupConsignments: async (params,data) => {
        const response = await getPickupConsignments(params,data);
        return response;
      },
      exportConsignments: async (params) => {
        const response = await exportConsignments(params);
        return response;
      },
      postConsignments: async (params) => {
        const response = await postConsignments(params);
        return response;
      },
        postConsignmentsV3: async (params) => {
        const response = await postConsignmentsV3(params);
        return response;
      },
      exportConsignmentsbyPost: async (params) => {
        const response = await exportConsignmentsbyPost(params);
        return response;
      },
      getConsignmentStatus: async () => {
        const response = await getConsignmentStatus();
        set({ consignmentStatus: response });
        return response;
      },
      getPickuprequestStatus: async () => {
        const response = await getPickuprequestStatus();
        set({ pickupStatus: response });
        return response;
      },
      printPickupRequests: async (params) => {
        const response = await printPickupRequests(params);
        return response;
      },
      postPickupScheduleDate: async (params,data) => {
        const response = await postPickupScheduleDate(params,data);
        return response;
      },
      postDeliveryScheduleDate: async (data) => {
        const response = await postDeliveryScheduleDate(data);
        return response;
      },
      postPickupReschedule: async (params,data) => {
        const response = await postPickupReschedule(params,data);
        return response;
      },
      postSingleSupplier: async (data) => {
        const response = await postSingleSupplier(data);
        return response;
      },
      getPackages: async (data) => {
        const response = await getPackages(data);
        return response;
      },
      exportPackages: async (data) => {
        const response = await exportPackages(data);
        return response;
      },
      postBulkSupplier: async (data) => {
        const response = await postBulkSupplier(data);
        return response;
      },
      setisPickupRequest: (data) => set({ isPickupRequest: data }),
      reassignPickupRequest: async (data) => {
        const response = await reassignPickupRequest(data);
        return response;
      },
      unassignPickupRequest: async (data) => {
        const response = await unassignPickupRequest(data);
        return response;
      },
      cancelPickupWaybills: async (data) => {
        const response = await cancelPickupWaybills(data);
        return response;
      },
});

pickupStore = devtools(pickupStore);

export const usepickupStore = create(pickupStore);